





















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Tree } from 'element-ui';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { ElementUIHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ElementUIHelper';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { APPTree } from '@/libs/com/MetaPattern/MDA/MD/APPTree';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { EnumComponentType, EnumComponentTypeMD } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { MDRepository } from '@/libs/com/MetaPattern/MDA/MD/MDRepository';
import { BEComponent } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { APPComponent } from '@/api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { MDService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/MDService';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { BEComponentService } from '@/api/com/MetaPattern/MDA/MD/EntityModel/BEComponentService';
import { APPService } from '@/api/com/MetaPattern/MDA/MD/Base/APPService';
import { APPComponentService } from '@/api/com/MetaPattern/MDA/MD/APPModel/APPComponentService';
import { MDValidation } from '@/libs/com/MetaPattern/MDA/MD/MDValidation';
import { ValidationResult } from '@/api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidateHelper } from '@/libs/com/MetaPattern/Product/IDE/Util/ValidateHelper';
import { WorkScope } from '@/api/com/MetaPattern/MDA/MD/Base/WorkScope';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { UIModelComponentService } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponentService';
import { DesignerExtendService } from '@/libs/com/MetaPattern/MDA/Designer/DesignerExtendService';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
import { DBComponent } from '@/api/com/MetaPattern/MDA/MD/DBModel/DBComponent';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { PipelineService } from '@/api/com/MetaPattern/APP/MDA/Pipeline/PipelineService';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { JointShapeRepository } from '@/libs/com/MetaPattern/MDA/Designer/Repository/JointShapeRepository';
import { BaseService } from '@/api/com/MetaPattern/MDA/MD/Base/BaseService';

@Component({
  components: {}
})
export default class APPInfo extends Vue {
  private tree: Array<APPTree>;
  private key = 0;
  expandedList: string[] = [];
  private loading = true;

  constructor() {
    super();
    this.loading = true;
  }

  get apps(): Array<APP> {
    const myAPPs = IDEContext.instance.filterMyAPPs(this.$store.state.ModuleMD.apps);
    if (myAPPs.length === 0) {
      MDExtendService.GetAPPTreeAsync('').then((response: Array<APP>) => {
        response.forEach(app => {
          if (ValidateHelper.IsNotNullOrEmpty(app.workScope_ID)) {
            app.workScope = this.$store.state.ModuleMD.workScopes.find((item: WorkScope) => item.id === app.workScope_ID);
          }
        });
        this.loading = false;
        this.$store.dispatch('ModuleMD/setAppsAction', response);
      });
    } else {
      this.loading = false;
    }
    return myAPPs;
  }

  set apps(value: Array<APP>) {
    this.$store.dispatch('ModuleMD/setAppsAction', value);
  }

  get appData() {
    this.tree = new Array<APPTree>();
    this.apps.forEach((app) => {
      app.dBComponents.length = 0;
      this.tree.push(new APPTree(app));
    });
    return this.tree;
  }

  get refreshKey() {
    return this.key;
  }

  get defaultProps() {
    return {
      label: 'displayName',
      children: 'components',
      designId: 'designId',
      status: 'status'
    };
  }

  get componentType() {
    return EnumComponentType;
  }

  getComponentTypeName(componentType: EnumComponentType) {
    if (componentType) {
      return '[' + EnumComponentTypeMD.getItemByValue(componentType).name.substring(0, 3) + ']';
    }
    return '';
  }

  getHasApp(): boolean {
    return this.apps.length > 0;
  }

  deletable(data: BaseComponent | APPTree) {
    if (data instanceof APPComponent) {
      return false;
    }
    return true;
  }

  /** 打开节点设置 */
  nodeSetting(data: BaseComponent | APPTree, evt: any) {
    // 如果是应用，则打开应用设置
    const curElement = this.$store.state.ModuleMD.elements.find((app: BaseElement) => app.designId === data.designId) as BaseElement;
    if (curElement instanceof APP) {
      EventBus.$emit('openPage', 'views/pages/APPPipeline.vue', `${curElement.name}Pipeline`, `${curElement.displayName}流水线`, { app: curElement, appId: curElement.id, appKey: curElement.aPPKey });
    }
    evt.stopPropagation();
  }

  handleNodeClick(data: BaseElement): void {
    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', data.designId);
  }

  /* 更新前设置扩展的节点，重新渲染即可选中。如果在点击事件中操作，则导致每次点击都会出发重新渲染树 */
  beforeUpdate(): void {
    if (this.$store.state.ModuleMD.curMDDesignId !== '') {
      this.expandedList = [];
      this.expandedList.push(this.$store.state.ModuleMD.curMDDesignId);
    }
    // console.log('APPInfo : beforeUpdate');
  }

  /* 数据更新后，设置当前高亮的节点 */
  updated(): void {
    if (this.$store.state.ModuleMD.curMDDesignId !== '') {
      (this.$refs.tree as Tree).setCurrentKey(this.$store.state.ModuleMD.curMDDesignId);
    }
    // console.log('APPInfo : updated');
  }

  openDoc(data: BaseComponent) {
    this.handleNodeClick(data);
    EventBus.$emit('openDoc', data);
    // if (data.componentType === EnumComponentType.UIModel) {
    //   EventBus.$emit('openPage', 'views/pages/UIModel.vue', `${data.name}UIModel`, `[UIM]${data.displayName}`, { componentId: data.designId });
    // } else {
    //   EventBus.$emit('openDoc', data);
    // }
  }

  /** 保存组件或应用 */
  save(data: BaseComponent | APPTree) {
    const errors = new Array<ValidationResult>();
    if (data instanceof APPTree) {
      MDValidation.validateAPP(data.app, errors);
      data.app.aPPComponents.forEach(component => {
        if (component.persistenceStatus !== EnumPersistenceStatus.None) {
          MDValidation.validateAPPComponent(component, errors);
        }
      });
      data.app.bEComponents.forEach(component => {
        if (component.persistenceStatus !== EnumPersistenceStatus.None) {
          MDValidation.validateBEComponent(component, errors);
        }
      });
    } else if (data instanceof BEComponent) {
      MDValidation.validateBEComponent(data, errors);
    } else if (data instanceof APPComponent) {
      MDValidation.validateAPPComponent(data, errors);
    }
    if (errors.length > 0) {
      this.$store.dispatch('ModuleMD/setValidationErrorsAction', errors);
      this.$message({ type: 'error', message: '校验失败，不能保存，请查看错误列表，修复后再保存!' });
      return;
    }
    if (data instanceof APPTree) {
      const app = new APP();
      app.copyFrom(data.app, false);
      MDService.SaveAPPAsync(app)
        .then((response) => {
          if (response) {
            const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === app.designId) as APP;
            if (element) {
              element.persistenceStatus = EnumPersistenceStatus.None;
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${app.displayName}] 保存成功。`);
            }
          }
        });
      data.app.aPPComponents.forEach(component => {
        if (component.persistenceStatus !== EnumPersistenceStatus.None) {
          this.saveComponent(component);
        }
      });
      data.app.bEComponents.forEach(component => {
        if (component.persistenceStatus !== EnumPersistenceStatus.None) {
          this.saveComponent(component);
        }
      });
      data.app.uIModelComponents.forEach(component => {
        if (component.persistenceStatus !== EnumPersistenceStatus.None) {
          this.saveComponent(component);
        }
      });
    } else if (data instanceof BaseComponent) {
      this.saveComponent(data);
    }
  }

  saveComponent(data: BaseComponent) {
    console.log('save component:' + data.name);
    let component: BaseComponent = null;
    if (data instanceof BEComponent) {
      component = new BEComponent();
    } else if (data instanceof APPComponent) {
      component = new APPComponent();
    } else if (data instanceof UIModelComponent) {
      component = new UIModelComponent();
    }
    if (component !== null) {
      component.copyFrom(data, false);
      const deleteDesignIds = new Array<string>();
      // 如果存在图形，则直接保存图形，同时保存组件，两者需要同步。
      const diagram = this.$store.state.ModuleMD.diagrams.find((diagram: any) => diagram.component.designId === component.designId) as Diagram;
      if (diagram && diagram.isModified) {
        // 将component的信息从elements中复制
        const component = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === diagram.component.designId);
        if (component) {
          diagram.component.copyFrom(component, false);
        }
        const deleteDesignIds = new Array<string>();
        JointShapeRepository.saveComponentAsync(diagram, deleteDesignIds)
          .then((response) => {
            diagram.saved();
            const component = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === diagram.component.designId);
            if (component) {
              diagram.component.persistenceStatus = EnumPersistenceStatus.None;
              component.persistenceStatus = EnumPersistenceStatus.None;
              deleteDesignIds.forEach(designId => {
                const deleteElement = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === designId) as BaseElement;
                if (deleteElement) {
                  this.$store.dispatch('ModuleMD/removeElementAction', { element: deleteElement, componentDesignId: component.designId });
                }
              });
            }
            const message = `组件 [${diagram?.component?.displayName}] 模型保存成功。`;
            this.output(message);
            this.$message({ type: 'success', message: message });
          })
          .catch((exp) => {
            const message = `组件 [${diagram?.component?.displayName}] 模型保存失败，失败原因：${exp}。`;
            this.output(message);
            this.$message({ type: 'error', message: message });
          });
      } else {
        MDExtendService.SaveComponentAsync(component, deleteDesignIds)
          .then((response) => {
            if (response) {
              const element = this.$store.state.ModuleMD.elements.find((item: BaseElement) => item.designId === component.designId) as BaseComponent;
              if (element) {
                element.persistenceStatus = EnumPersistenceStatus.None;
                this.$store.dispatch('ModuleMD/setOutputMessagesAction', `组件 [${component.displayName}] 保存成功。`);
              }
            }
          });
      }
    }
  }

  output(message: string) {
    this.$store.dispatch('ModuleMD/setOutputMessagesAction', message);
  }

  /** 删除组件或应用 */
  deleteNode(data: BaseComponent | APPTree) {
    let message = '';
    if (data instanceof BaseComponent) {
      message = `此操作将永久删除组件 [${data.displayName}]，不可恢复，是否继续?`;
    } else if (data instanceof APPTree) {
      message = `此操作将永久删除应用 [${data.displayName}] 以及其下属的组件，不可恢复，是否继续?`;
    }
    this.$confirm(message, '删除提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (data instanceof APPTree) {
        this.deleteAPP(data);
      } else if (data instanceof BaseComponent) {
        this.deleteComponent(data);
      }
    }).catch(() => {
      // 取消删除
    });
  }

  /** 发布到模型库 */
  publishUnit(data: BaseComponent | APPTree) {
    // 如果是应用，则打开应用设置
    const curElement = this.$store.state.ModuleMD.elements.find((app: BaseElement) => app.designId === data.designId) as BaseElement;
    if (curElement instanceof APP) {
      EventBus.$emit('openPage', 'views/pages/PublishUnit.vue', '发布到模型库', '发布到模型库', { app: curElement, appId: curElement.id, appKey: curElement.aPPKey });
    }
  }

  /** 删除应用及下面的所有组件，并保存 */
  deleteAPP(data: APPTree) {
    const findAPP = this.apps.find(app => data.id === app.id);
    if (findAPP) {
      if (findAPP.persistenceStatus === EnumPersistenceStatus.Create) {
        this.deleteAPPDone(findAPP);
      } else {
        BaseService.DeleteAPPAsync(findAPP.id)
          .then((res) => {
            if (res) {
              this.deleteAPPDone(findAPP);
            } else {
              this.$message({ type: 'error', message: '删除应用失败!' });
              this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${findAPP.displayName}] 删除失败！`);
            }
          })
          .catch((error: any) => {
            this.$message({ type: 'error', message: '删除应用失败!原因是：' + error });
            this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${findAPP.displayName}] 删除失败！原因是：${error}`);
          });
      }
    }
  }

  /** 删除应用结束后 */
  deleteAPPDone(findAPP: APP) {
    const apps = this.$store.state.ModuleMD.apps as Array<APP>;
    let findIndex = apps.findIndex((app: APP) => app.designId === findAPP.designId);
    if (findIndex > -1) {
      apps.splice(findIndex, 1);
    }
    const elements = this.$store.state.ModuleMD.elements as Array<BaseElement>;
    findIndex = elements.findIndex((element: BaseElement) => element.designId === findAPP.designId);
    if (findIndex > -1) {
      elements.splice(findIndex, 1);
    }
    findAPP.aPPComponents.forEach(component => {
      findIndex = elements.findIndex((element: BaseElement) => element.designId === component.designId);
      if (findIndex > -1) {
        elements.splice(findIndex, 1);
      }
    });
    findAPP.bEComponents.forEach(component => {
      findIndex = elements.findIndex((element: BaseElement) => element.designId === component.designId);
      if (findIndex > -1) {
        elements.splice(findIndex, 1);
      }
    });

    this.$message({ type: 'success', message: '删除应用成功!' });
    this.$store.dispatch('ModuleMD/setOutputMessagesAction', `应用 [${findAPP.displayName}] 及下属所有组件 删除成功`);
  }

  /** 删除组件 */
  deleteComponent(component: BaseComponent) {
    const findAPP = this.apps.find(app => component.aPP_ID === app.id);
    if (findAPP) {
      if (component instanceof BEComponent) {
        if (component.persistenceStatus === EnumPersistenceStatus.Create) {
          findAPP.bEComponents.splice(findAPP.bEComponents.findIndex(item => item.designId === component.designId), 1);
          this.deleteComponentDone(component);
        } else {
          BEComponentService.DeleteAsync(component.id).then(() => {
            findAPP.bEComponents.splice(findAPP.bEComponents.findIndex(item => item.designId === component.designId), 1);
            this.deleteComponentDone(component);
          });
        }
      } else if (component instanceof UIModelComponent) {
        if (component.persistenceStatus === EnumPersistenceStatus.Create) {
          findAPP.uIModelComponents.splice(findAPP.uIModelComponents.findIndex(item => item.designId === component.designId), 1);
          this.deleteComponentDone(component);
        } else {
          UIModelComponentService.DeleteAsync(component.id).then(() => {
            findAPP.uIModelComponents.splice(findAPP.uIModelComponents.findIndex(item => item.designId === component.designId), 1);
            this.deleteComponentDone(component);
          });
        }
      }
    }
  }

  /** 删除组件完成后 */
  deleteComponentDone(component: BaseComponent) {
    const elements = this.$store.state.ModuleMD.elements;
    elements.splice(elements.findIndex((element: BaseElement) => element.designId === component.designId), 1);
    component.persistenceStatus = EnumPersistenceStatus.Delete;
    this.$store.dispatch('ModuleMD/setCurMDElementAction', null);
    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', '');
    this.$message({ type: 'success', message: '删除组件成功!' });
    this.$store.dispatch('ModuleMD/setOutputMessagesAction', `组件 [${component.displayName}] 删除成功。`);
  }

  hasModified(data: any) {
    let persistenceStatus: EnumPersistenceStatus;
    if (data instanceof APPTree) {
      persistenceStatus = data.app.persistenceStatus;
    } else if (data instanceof BaseElement) {
      persistenceStatus = data.persistenceStatus;
    }
    return persistenceStatus !== EnumPersistenceStatus.None;
  }

  /**
   * 下拉菜单命令处理
   * @param action 命令：命令名称、数据
   */
  menuCommand(action: any) {
    if (action.command) {
      if (action.command === 'createAPP' || action.command === 'createBE' || action.command === 'createDB') {
        const app = this.apps.find((app) => app.designId === action.data);
        if (app !== null) {
          let componentType = EnumComponentType.APP;
          if (action.command === 'createAPP') {
            componentType = EnumComponentType.APP;
          } else if (action.command === 'createBE') {
            componentType = EnumComponentType.BE;
          } else if (action.command === 'createDB') {
            componentType = EnumComponentType.DB;
          }
          const component = MDRepository.createAPPComponent(app, componentType);
          if (component !== null) {
            app.modify(true);
            this.key++;
            this.$store.dispatch('ModuleMD/setElementAction', { element: component, componentDesignId: component.designId });
          }
        }
      } else if (action.command === 'deleteNode') {
        this.deleteNode(action.data);
      } else if (action.command === 'publishUnit') {
        this.publishUnit(action.data);
      } else if (action.command === 'convertToUIModel') {
        // 转化为UI模型，如果存在，则进行同步
        const beComponent = action.data as BEComponent;
        this.convertBEToUIModelComponent(beComponent);
      }
    }
  }

  /** 将BE组件转化为UI模型组件 */
  convertBEToUIModelComponent(beComponent: BEComponent) {
    const loading = this.$loading({
      lock: true,
      text: '正在努力转换模型，请耐心等待。。。',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    PipelineService.BEToUIModelAsync(beComponent.designId)
      .then((uiModelComponent: UIModelComponent) => {
        const app = beComponent.aPP;
        const findUIModel = app.uIModelComponents.find(item => item.designId === uiModelComponent.designId);
        if (findUIModel) {
          findUIModel.copyFrom(uiModelComponent, false);
          findUIModel.persistenceStatus = EnumPersistenceStatus.None;
        } else {
          uiModelComponent.persistenceStatus = EnumPersistenceStatus.None;
          uiModelComponent.aPP = app;
          app.uIModelComponents.push(uiModelComponent);
        }
        EventBus.$emit('removeTab', uiModelComponent.designId); // 关闭多文档中已经打开的组件
        this.$message({ type: 'success', message: '组件转化成功，请重新打开组件加载内容!' });
        this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', uiModelComponent.designId);
        this.$store.dispatch('ModuleMD/setCurMDElementAction', { element: uiModelComponent });
        this.$store.dispatch('ModuleMD/setOutputMessagesAction', `业务组件 [${beComponent.displayName}] 转化为 [${uiModelComponent.displayName}] 操作成功。`);
        ElementUIHelper.expendNode(this.$refs.tree as Tree, app.designId);
        loading.close();
      });
  }

  hasAPPComponent(app: APP): boolean {
    return app.aPPComponents.length === 1;
  }

  getTypeIcon(data: any) {
    let typeName = '';
    const element = data;
    if (element) {
      if (element instanceof APP) {
        typeName = MDAConstant.Type.ADD_APP;
      } else if (element instanceof APPComponent) {
        typeName = MDAConstant.Type.ADD_APPCOMPONENT;
      } else if (element instanceof BEComponent) {
        typeName = MDAConstant.Type.ADD_BECOMPONENT;
      } else if (element instanceof DBComponent) {
        typeName = MDAConstant.Type.ADD_DBCOMPONENT;
      } else if (element instanceof UIModelComponent) {
        typeName = MDAConstant.Type.ADD_UIMODELCOMPONENT;
      }
    }
    if (typeName !== '') {
      return DesignerExtendService.getTypeIcon(typeName);
    }
    return '';
  }
}
